import { IContractorUser, ITCUser } from '@typedefs/users';
import api from './api';
import { get } from './utils';

export const getTCUserInfo = async (profileId: string, token: string) => {
  return get<{ results: ITCUser }>(api.tc.getProfile(profileId), { token });
};

export const getContractorUserInfo = async (profileId: string, token: string) => {
  return get<{ results: IContractorUser }>(api.contractors.getUserProfile(profileId), { token });
};
